import {
  CellRendererGray,
  CellRendererRed,
  CellRendererButton,
} from 'components/gifts-table/TableList';

export const columns = (showTable) => [
  {
    label: { evento: 'Mesa de regalos' },
    renderer: (item) => CellRendererRed(item.tipo, item.evento),
  },
  {
    
    renderer: (item) => CellRendererRed(item.festejados),
  },
  {
    
    renderer: (item) => CellRendererRed(item.fecha),
  },
  {
    label: '',
    noRenderer: true,
    field: '',
    renderer: (item) => (
      <CellRendererButton onClick={() => showTable(item)}>
        Ver mesa
      </CellRendererButton>
    ),
  },
];
